<div class="alert" [ngClass]="['lt-alert-' + severity(), 'lt-alert-variant-' + variant()]">
  @if (resolvedIcon()) {
    <div class="alert-icon">
      <lt-icon [name]="resolvedIcon()" [ngClass]="resolvedIcon()" aria-hidden="true"></lt-icon>
    </div>
  }
  <div class="alert-body">
    <div class="alert-content">
      @if (title()) {
        <span class="alert-header">
          {{ title() }}
        </span>
      }
      @if (message()) {
        <span class="alert-description">
          {{ message() }}
        </span>
      }
      <ul class="alert-items">
        @for (item of items(); track $index) {
          <li class="alert-item">{{ item }}</li>
        }
      </ul>
    </div>
    @if (submit()) {
      <div class="alert-submit">
        <a
          data-id="button"
          class="alert-submit weight-600"
          [ngClass]="[
            'alert-submit-' + submitType(),
            submitType() === 'button' ? 'alert-submit-button alert-submit-button--' + submitButtonStyle() : ''
          ]"
          data-testid="alert-submit-btn"
          (click)="onSubmitClick()"
        >
          @if (resolvedSubmitButtonIcon(); as iconName) {
            <lt-icon [name]="iconName" [ngClass]="iconName"></lt-icon>
          }
          {{ submitLabel() }}
        </a>
      </div>
    }
  </div>
  @if (closeable()) {
    <button
      type="button"
      class="alert-close"
      aria-label="Close alert"
      (click)="onCloseClick()"
      data-testid="alert-close-btn"
    >
      <lt-icon name="fa-sharp-solid-times" aria-hidden="true"></lt-icon>
    </button>
  }
</div>
